import React from 'react';
import ReactDOM from 'react-dom/client';
import { MoviesApp } from './MoviesApp'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <MoviesApp />
  </>
);
